import { render } from "./DockoutBooking.vue?vue&type=template&id=cabe86bc&scoped=true"
import script from "./DockoutBooking.vue?vue&type=script&lang=js"
export * from "./DockoutBooking.vue?vue&type=script&lang=js"

import "./DockoutBooking.vue?vue&type=style&index=0&id=cabe86bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cabe86bc"]])

export default __exports__